import { render } from "./ProjectsTable.vue?vue&type=template&id=41f7207c&scoped=true"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"

import "./ProjectsTable.vue?vue&type=style&index=0&id=41f7207c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f7207c"]])

export default __exports__